import { useState } from "react";
import { toast } from "sonner";
import { FileArchive } from "lucide-react";
import { download } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export const RicevuteZipDialog = () => {
  const now = new Date();
  const [open, setOpen] = useState(false);
  const [anno, setAnno] = useState(String(now.getFullYear()));
  const [mese, setMese] = useState(String(now.getMonth() + 1));
  const [busy, setBusy] = useState(false);
  const anni = Array.from({ length: 6 }, (_, i) => String(now.getFullYear() - i));
  const go = async () => {
    setBusy(true);
    try { await download("/company/sdi/ricevute.zip", { anno, mese }); setOpen(false); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" className="bg-white" data-testid="ricevute-sdi-button" onClick={() => setOpen(true)}><FileArchive className="mr-2 h-4 w-4" />Ricevute SdI</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="ricevute-sdi-dialog">
          <DialogHeader>
            <DialogTitle>Ricevute SdI in un unico file</DialogTitle>
            <DialogDescription>Un file ZIP con le cartelle XML (ricevute ufficiali) e PDF (copie leggibili), più l'elenco delle ricevute mancanti.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <Select value={mese} onValueChange={setMese}>
              <SelectTrigger data-testid="ricevute-mese-select"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="0">Tutto l'anno</SelectItem>{MESI.map((m, i) => <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>)}</SelectContent>
            </Select>
            <Select value={anno} onValueChange={setAnno}>
              <SelectTrigger data-testid="ricevute-anno-select"><SelectValue /></SelectTrigger>
              <SelectContent>{anni.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <DialogFooter><Button data-testid="ricevute-download-button" disabled={busy} className="bg-sky-600 hover:bg-sky-700" onClick={go}>{busy ? "Preparazione…" : "Scarica ZIP"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
